import { inject } from 'inversify';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { IRepo, IRepoResponse } from '@core/repo';
import { urlMaker } from '@core/utils';
import { bind } from '@infra/container';

export type IGetTransactionsReportRepoResponse = IRepoResponse<200, Blob> | IRepoResponse<400 | 500, string>;

export type IGetTransactionsReportRepo = IRepo<[any], IGetTransactionsReportRepoResponse>;

export const GetTransactionsReportRepoType = Symbol.for('GetTransactionsReportRepo');

@bind(GetTransactionsReportRepoType)
export class GetTransactionsReportRepo implements IGetTransactionsReportRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(query: any) {
    try {
      const result = await this.httpClient.get({ url: urlMaker('/api/admin/pay/export', query) });

      if (result.status === 200) {
        const file = await result.blob();

        return {
          status: 200 as 200,
          response: file,
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi.',
      };
    }
  }
}
